module.exports = __webpack_public_path__ + "img/15-7.b4e99f2c.jpg";